import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Flex, Tooltip } from 'antd';

const ColumnHeaderTooltip = ({
  title,
  tooltip,
}: {
  title: string;
  tooltip?: string;
}) => {
  return (
    <Flex align="center" gap={10}>
      <span>{title}</span>
      <Tooltip title={tooltip}>
        <ExclamationCircleOutlined
          height={6}
          width={6}
          style={{ color: '#000' }}
        />
      </Tooltip>
    </Flex>
  );
};

export default ColumnHeaderTooltip;
